import { useState } from 'react'

export const useModalCommon = (defaultValue = false) => {
	const [visible, setVisible] = useState(defaultValue)

	const openModal = e => {
		e && e.stopPropagation()
		setVisible(true)
	}

	const closeModal = e => {
		e && e.stopPropagation()
		setVisible(false)
	}

	return {
		visible,
		openModal,
		closeModal,
	}
}
